var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c(
        "nav",
        {
          staticClass:
            "navbar navbar-lg navbar-expand-lg navbar-transparant navbar-dark navbar-absolute w-100 justify-content-between"
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "dropdown" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-white dropdown-toggle mr-2",
                attrs: {
                  type: "button",
                  "data-toggle": "dropdown",
                  "aria-haspopup": "true",
                  "aria-expanded": "false"
                }
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("navbar.language")) + "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "dropdown-menu" }, [
              _c(
                "button",
                {
                  staticClass: "dropdown-item",
                  on: {
                    click: function($event) {
                      return _vm.changeLanguage("en")
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("languageChoice.English")) +
                      "\n        "
                  )
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: " pt-8 pb-3 position-relative" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "intro-content mt-0 mt-md-5 text-white" }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6 align-self-center" }, [
                _c("h1", { staticClass: "display-4 mb-3" }, [
                  _vm._v(_vm._s(_vm.$t("Landing.text1"))),
                  _c("br"),
                  _vm._v(_vm._s(_vm.$t("Landing.text2")))
                ]),
                _vm._v(" "),
                _c("h2", { staticClass: "mb-1" }, [
                  _vm._v(_vm._s(_vm.$t("Landing.text4")))
                ]),
                _vm._v(" "),
                _c("h5", {
                  staticClass: "lead mb-4",
                  domProps: { innerHTML: _vm._s(_vm.$t("Landing.text3")) }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-5 ml-auto" }, [
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-body text-dark" }, [
                    _c(
                      "form",
                      {
                        staticClass: "demo-ruleForm needs-validation-sign-up",
                        attrs: { "label-width": "0px", novalidate: "" }
                      },
                      [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "email" } }, [
                            _vm._v(_vm._s(_vm.$t("LandingForm.Email")))
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.email,
                                expression: "email"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "email",
                              id: "email",
                              required: "",
                              placeholder: _vm.$t(
                                "LandingForm.Emailplaceholder"
                              )
                            },
                            domProps: { value: _vm.email },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.email = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\n                      " +
                                _vm._s(_vm.$t("LandingForm.emailTips")) +
                                "\n                    "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "password" } }, [
                            _vm._v(_vm._s(_vm.$t("LandingForm.Password")))
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.password,
                                expression: "password"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "password",
                              id: "password",
                              required: "",
                              placeholder: _vm.$t(
                                "LandingForm.Passwordplaceholder"
                              )
                            },
                            domProps: { value: _vm.password },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.password = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\n                      " +
                                _vm._s(_vm.$t("LandingForm.PasswordTips")) +
                                "\n                    "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "checkPassword" } }, [
                            _vm._v(_vm._s(_vm.$t("LandingForm.Repeatpassword")))
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.checkPassword,
                                expression: "checkPassword"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "password",
                              id: "checkPassword",
                              required: "",
                              placeholder: _vm.$t(
                                "LandingForm.Repeatpsdplaceholder"
                              )
                            },
                            domProps: { value: _vm.checkPassword },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.checkPassword = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\n                      " +
                                _vm._s(_vm.$t("LandingForm.RepeatpsdTips")) +
                                "\n                    "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "invalid-feedback password-not-match",
                              staticStyle: { display: "none" }
                            },
                            [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.$t("LandingForm.PsdAndPassword")) +
                                  "\n                    "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-success btn-block btn-lg mb-2 mt-4",
                            attrs: { type: "submit" },
                            on: { click: _vm.signUp }
                          },
                          [_vm._v(_vm._s(_vm.$t("LandingForm.Signup")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("LandingForm.SigninLeft")) +
                                "\n                    "
                            ),
                            _c(
                              "router-link",
                              { attrs: { to: "/user/login" } },
                              [_vm._v(_vm._s(_vm.$t("LandingForm.Signin")))]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "ml-3 mt-3 text-left",
              staticStyle: { width: "80px" }
            },
            [
              _c(
                "a",
                {
                  staticStyle: { "border-bottom-style": "none" },
                  attrs: {
                    href: _vm.$t("LandingForm.TwitterLink"),
                    target: "_blank"
                  }
                },
                [
                  _c("img", {
                    staticClass: "img-fluid",
                    attrs: {
                      src: require("../../../static/img/landing/Twitter_WHITE.png")
                    }
                  })
                ]
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("main", { staticClass: "main", attrs: { role: "main" } }, [
        _c("div", { staticClass: "bg-white pb-6" }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "landing-video-container row" }, [
              _c("video", {
                attrs: {
                  id: "landing-video",
                  src: require("../../../static/img/promo00.mp4"),
                  autobuffer: "",
                  autoplay: "",
                  muted: "",
                  controls: "",
                  loop: ""
                },
                domProps: { muted: true }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row pt-3" }, [
              _c("div", { staticClass: "col-md-4 offset-md-1 pl-3 pl-md-4" }, [
                _c("h2", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("LandingCentertext1.textTop1"))
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6 " }, [
                _c("p", { staticClass: "lead text-dark" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("LandingCentertext1.textTop2")) +
                      "\n            "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-5" }, [
              _c("div", { staticClass: "col-md-4" }, [
                _c("div", { staticClass: "media" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("div", { staticClass: "media-body" }, [
                    _c("h3", { staticClass: "h4" }, [
                      _vm._v(_vm._s(_vm.$t("LandingCentertext1.Sustainable")))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "text-dark text-left" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("LandingCentertext1.WhereverText")) +
                          "\n                "
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-4" }, [
                _c("div", { staticClass: "media" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c("div", { staticClass: "media-body" }, [
                    _c("h3", { staticClass: "h4" }, [
                      _vm._v(_vm._s(_vm.$t("LandingCentertext1.Secure")))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "text-dark text-left" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("LandingCentertext1.WheneverText")) +
                          "\n                "
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-4" }, [
                _c("div", { staticClass: "media" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c("div", { staticClass: "media-body" }, [
                    _c("h3", { staticClass: "h4" }, [
                      _vm._v(_vm._s(_vm.$t("LandingCentertext1.Convenience")))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "text-dark text-left" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("LandingCentertext1.WhoeverText")) +
                          "\n                "
                      )
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bg-light py-6" }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-4 offset-md-1 pl-3 pl-md-4" }, [
                _c("h2", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("LandingCentertext2.textTop1"))
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("p", { staticClass: "lead text-dark" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("LandingCentertext2.textTop2")) +
                      "\n            "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _vm._m(5)
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bg-white pt-6 " }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-4 offset-md-1 pl-3 pl-md-4" }, [
                _c("h2", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("LandingCentertext3.textTop1"))
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("p", { staticClass: "lead text-dark" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("LandingCentertext3.textTop2")) +
                      "\n            "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-md-12 p-0 center-vertical",
                staticStyle: { "justify-content": "center" }
              },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-success btn-block btn-lg mb-2 mt-4 col-md-4",
                    on: { click: _vm.goTop }
                  },
                  [_vm._v(_vm._s(_vm.$t("Landing.tryToService")))]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mt-5 card3" }, [
              _c("div", { staticStyle: { width: "1200px" } }, [
                _vm._m(6),
                _vm._v(" "),
                _vm._m(7),
                _vm._v(" "),
                _vm._m(8),
                _vm._v(" "),
                _vm._m(9),
                _vm._v(" "),
                _vm._m(10),
                _vm._v(" "),
                _vm._m(11),
                _vm._v(" "),
                _vm._m(12),
                _vm._v(" "),
                _vm._m(13),
                _vm._v(" "),
                _vm._m(14),
                _vm._v(" "),
                _vm._m(15),
                _vm._v(" "),
                _vm._m(16),
                _vm._v(" "),
                _vm._m(17),
                _vm._v(" "),
                _vm._m(18),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "card2-img",
                    staticStyle: {
                      "font-size": "28px",
                      "font-weight": "bold",
                      "margin-left": "-265px",
                      top: "-70px"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("LandingCentertext3.text1")))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "card2-img",
                    staticStyle: {
                      "font-size": "28px",
                      "font-weight": "bold",
                      "margin-left": "-30px",
                      top: "70px"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("LandingCentertext3.text2")))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "card2-img",
                    staticStyle: {
                      "font-size": "46px",
                      "font-weight": "bold",
                      "margin-left": "20px",
                      top: "90px"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("LandingCentertext3.text3")))]
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "card2-img",
                  staticStyle: {
                    "font-size": "13px",
                    "font-weight": "bold",
                    "margin-left": "-100px",
                    top: "-90px"
                  },
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("LandingCentertext3.text4"))
                  }
                })
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bg-light py-6" }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _vm._m(19),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6 center-vertical" }, [
                _c("div", { staticClass: "lead text-dark" }, [
                  _c("h2", [
                    _vm._v(_vm._s(_vm.$t("LandingCentertext4.textTop1")))
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("LandingCentertext4.textTop2")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12 p-0 center-vertical" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-success btn-block btn-lg mb-2 mt-4 col-md-8",
                        on: { click: _vm.goTop }
                      },
                      [_vm._v(_vm._s(_vm.$t("Landing.tryToService")))]
                    )
                  ])
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "py-6 text-white",
            staticStyle: { "background-color": "rgb(255, 128, 128)" }
          },
          [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-4 offset-md-1 pl-3 pl-md-4" },
                  [
                    _c("h2", [
                      _vm._v(_vm._s(_vm.$t("LandingBottom1.Title"))),
                      _c("br"),
                      _vm._v(" " + _vm._s(_vm.$t("LandingBottom1.Title2")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-6" }, [
                  _c("p", { staticClass: "lead text-white" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("LandingBottom1.TitleTips")) +
                        "\n            "
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(20)
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "bg-light py-6" }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6 center-vertical" }, [
                _c("div", { staticClass: "lead text-dark" }, [
                  _c("h2", [
                    _vm._v(_vm._s(_vm.$t("LandingCentertext5.textTop1")))
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("LandingCentertext5.textTop2"))
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12 p-0 center-vertical" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-success btn-block btn-lg mb-2 mt-4 col-md-8",
                        on: { click: _vm.goTop }
                      },
                      [_vm._v(_vm._s(_vm.$t("Landing.tryToService")))]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._m(21)
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bg-white pt-6" }, [
          _c("div", { staticClass: "col-12 col-md-9 mx-auto" }, [
            _c("div", {}, [
              _c("div", { staticClass: "col-md-12 text-center" }, [
                _c("div", { staticClass: "lead text-dark" }, [
                  _c("h2", [
                    _vm._v(_vm._s(_vm.$t("LandingCentertext6.textTop1")))
                  ]),
                  _vm._v(" "),
                  _c("h3", [
                    _vm._v(_vm._s(_vm.$t("LandingCentertext6.textTop2")))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pt-6 mt-6 mb-5 card6-1" }, [
                _c("div", { staticStyle: { width: "1300px" } }, [
                  _vm._m(22),
                  _vm._v(" "),
                  _vm._m(23),
                  _vm._v(" "),
                  _vm._m(24),
                  _vm._v(" "),
                  _vm._m(25),
                  _vm._v(" "),
                  _vm._m(26),
                  _vm._v(" "),
                  _vm._m(27),
                  _vm._v(" "),
                  _vm._m(28),
                  _vm._v(" "),
                  _vm._m(29),
                  _vm._v(" "),
                  _vm._m(30),
                  _vm._v(" "),
                  _vm._m(31),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "card6-img",
                    staticStyle: {
                      "font-size": "26px",
                      "font-weight": "bold",
                      "margin-left": "-1094px",
                      top: "26px",
                      color: "#ffffff"
                    },
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("LandingCentertext6.text1"))
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "card6-img",
                      staticStyle: {
                        "font-size": "16px",
                        "font-weight": "bold",
                        "margin-left": "118px",
                        top: "40px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("LandingCentertext6.text2")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "card6-img",
                      staticStyle: {
                        "font-size": "16px",
                        "font-weight": "bold",
                        "margin-left": "168px",
                        top: "80px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("LandingCentertext6.text3")))]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "card6-img text-center",
                    staticStyle: {
                      "font-size": "16px",
                      "font-weight": "bold",
                      "margin-left": "138px",
                      top: "135px"
                    },
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("LandingCentertext6.text4"))
                    }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "card6-img",
                    staticStyle: {
                      "font-size": "16px",
                      "font-weight": "bold",
                      "margin-left": "160px",
                      top: "120px"
                    },
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("LandingCentertext6.text5"))
                    }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "card6-img",
                    staticStyle: {
                      "font-size": "23px",
                      "font-weight": "bold",
                      "margin-left": "-932px",
                      top: "-130px"
                    },
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("LandingCentertext6.step1"))
                    }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "card6-img",
                    staticStyle: {
                      "font-size": "23px",
                      "font-weight": "bold",
                      "margin-left": "152px",
                      top: "-130px"
                    },
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("LandingCentertext6.step2"))
                    }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "card6-img",
                    staticStyle: {
                      "font-size": "23px",
                      "font-weight": "bold",
                      "margin-left": "136px",
                      top: "-130px"
                    },
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("LandingCentertext6.step3"))
                    }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "card6-img",
                    staticStyle: {
                      "font-size": "23px",
                      "font-weight": "bold",
                      "margin-left": "162px",
                      top: "-130px"
                    },
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("LandingCentertext6.step4"))
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row col-md-12" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-12 text-center" }, [
                _c("div", { staticClass: "lead text-dark" }, [
                  _c("h2", [
                    _vm._v(_vm._s(_vm.$t("LandingCentertext6.textTop3")))
                  ]),
                  _vm._v(" "),
                  _c("h3", [
                    _vm._v(_vm._s(_vm.$t("LandingCentertext6.textTop4")))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-3 pt-6 mb-3 card6-2" }, [
                _c("div", { staticStyle: { width: "1300px" } }, [
                  _vm._m(32),
                  _vm._v(" "),
                  _vm._m(33),
                  _vm._v(" "),
                  _vm._m(34),
                  _vm._v(" "),
                  _vm._m(35),
                  _vm._v(" "),
                  _vm._m(36),
                  _vm._v(" "),
                  _vm._m(37),
                  _vm._v(" "),
                  _vm._m(38),
                  _vm._v(" "),
                  _vm._m(39),
                  _vm._v(" "),
                  _vm._m(40),
                  _vm._v(" "),
                  _vm._m(41),
                  _vm._v(" "),
                  _vm._m(42),
                  _vm._v(" "),
                  _vm._m(43),
                  _vm._v(" "),
                  _vm._m(44),
                  _vm._v(" "),
                  _vm._m(45),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "card6-img",
                      staticStyle: {
                        "font-size": "16px",
                        "font-weight": "bold",
                        "margin-left": "-1028px",
                        top: "40px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("LandingCentertext6.text2")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "card6-img",
                      staticStyle: {
                        "font-size": "16px",
                        "font-weight": "bold",
                        "margin-left": "156px",
                        top: "80px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("LandingCentertext6.text3")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "card6-img",
                      staticStyle: {
                        "font-size": "16px",
                        "font-weight": "bold",
                        "margin-left": "206px",
                        top: "50px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("LandingCentertext6.text2")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "card6-img",
                      staticStyle: {
                        "font-size": "16px",
                        "font-weight": "bold",
                        "margin-left": "202px",
                        top: "-120px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("LandingCentertext6.text5")))]
                  ),
                  _vm._v(" "),
                  _vm._m(46),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "card6-img",
                      staticStyle: {
                        "font-size": "26px",
                        "font-weight": "bold",
                        "margin-left": "-236px",
                        top: "1px",
                        color: "#fff"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("LandingCentertext6.text6")))]
                  )
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("copyright"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "registSuccess",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "registSuccess",
            "aria-hidden": "true"
          }
        },
        [
          _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "h4",
                  {
                    staticClass: "modal-title",
                    attrs: { id: "authenticatorModalLabel" }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("registSuccess.Title")) +
                        "\n          "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body text-left pt-5 pb-5" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("registSuccess.TitleTips")) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer pt-5 pb-3" }, [
                _c("div", { staticClass: " col-12 text-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-lg btn-primary",
                      attrs: { "data-dismiss": "modal" }
                    },
                    [_vm._v(_vm._s(_vm.$t("registSuccess.OK")))]
                  )
                ])
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-left scales-logo-white" }, [
      _c("img", {
        staticClass: "img-fluid",
        attrs: {
          src: require("../../../static/img/landing/SCALES-LOGO-WHITE.png")
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("img", {
        staticClass: "img-fluid img-cover",
        attrs: {
          src: require("../../../static/img/landing/TOP_Backgrand_1200-800.png")
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon mr-3" }, [
      _c("i", { staticClass: "far fa-id-badge" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon mr-3" }, [
      _c("i", { staticClass: "far fa-hand-scissors" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon mr-3" }, [
      _c("i", { staticClass: "far fa-comments" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "row mt-5 col-12 col-md-12 no-gutters px-3 px-md-0" },
      [
        _c(
          "div",
          { staticClass: "col-4 col-md-4 px-0 px-md-3 center-vertical" },
          [
            _c("img", {
              staticClass: "img-fluid",
              attrs: { src: require("../../../static/img/landing/card1-1.png") }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-3 col-md-3 px-0 px-md-3 center-vertical" },
          [
            _c("img", {
              staticClass: "img-fluid",
              attrs: { src: require("../../../static/img/landing/card1-2.png") }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-3 col-md-3 px-0 px-md-3 center-vertical" },
          [
            _c("img", {
              staticClass: "img-fluid",
              attrs: { src: require("../../../static/img/landing/card1-3.png") }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-2 col-md-2 px-1 px-md-3 center-vertical" },
          [
            _c("img", {
              staticClass: "img-fluid",
              attrs: { src: require("../../../static/img/landing/card1-4.png") }
            })
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "card2-img", staticStyle: { width: "300px" } },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card2-1.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card2-img",
        staticStyle: { width: "150px", top: "50px", "margin-left": "-60px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card2-2.svg") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card2-img",
        staticStyle: { width: "500px", "margin-left": "15px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card2-3.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card2-img",
        staticStyle: { width: "100px", "margin-left": "-555px", top: "50px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card2-10.svg") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card2-img",
        staticStyle: { width: "180px", "margin-left": "0px", top: "10px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card2-4.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card2-img",
        staticStyle: { width: "100px", "margin-left": "0px", top: "10px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card2-10.svg") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card2-img",
        staticStyle: { width: "150px", "margin-left": "0px", top: "-20px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card2-5.svg") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card2-img",
        staticStyle: { width: "100px", "margin-left": "0px", top: "-30px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card2-10.svg") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card2-img",
        staticStyle: { width: "150px", "margin-left": "0px", top: "-30px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card2-8.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card2-img",
        staticStyle: { width: "100px", "margin-left": "-80px", top: "-60px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card2-9.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card2-img",
        staticStyle: { width: "150px", "margin-left": "-700px", top: "160px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card6-3.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card2-img",
        staticStyle: { width: "120px", "margin-left": "120px", top: "210px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card2-7.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card2-img",
        staticStyle: {
          width: "100px",
          transform: "rotate(180deg)",
          "margin-left": "-235px",
          top: "150px"
        }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card2-11.svg") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6 pl-3 pl-md-4" }, [
      _c("img", {
        staticClass: "img-fluid",
        attrs: { src: require("../../../static/img/landing/card3-1.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mx-auto" }, [
      _c(
        "div",
        {
          staticClass:
            "row align-items-center my-md-4 text-center col-12 no-gutters p-0"
        },
        [
          _c(
            "div",
            { staticClass: "col-3 col-md-3 px-0 px-md-3 center-vertical" },
            [
              _c("img", {
                staticClass: "img-fluid",
                attrs: {
                  src: require("../../../static/img/landing/card4-1.png")
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-3 col-md-3 px-1 px-md-3 center-vertical" },
            [
              _c("img", {
                staticClass: "img-fluid",
                attrs: {
                  src: require("../../../static/img/landing/card4-2.png")
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-3 col-md-3 px-1 px-md-3 center-vertical" },
            [
              _c("img", {
                staticClass: "img-fluid",
                attrs: {
                  src: require("../../../static/img/landing/card4-3.png")
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-3 col-md-3 px-1 px-md-3 pr-md-0 center-vertical"
            },
            [
              _c("img", {
                staticClass: "img-fluid",
                attrs: {
                  src: require("../../../static/img/landing/card4-4.png")
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-3 col-md-3 px-1 px-md-3 center-vertical" },
            [
              _c("img", {
                staticClass: "img-fluid",
                attrs: {
                  src: require("../../../static/img/landing/card4-5.png")
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-3 col-md-3 px-1 px-md-3 center-vertical" },
            [
              _c("img", {
                staticClass: "img-fluid",
                attrs: {
                  src: require("../../../static/img/landing/card4-6.png")
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-3 col-md-3 px-1 px-md-3 center-vertical" },
            [
              _c("img", {
                staticClass: "img-fluid",
                attrs: {
                  src: require("../../../static/img/landing/card4-7.png")
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-3 col-md-3 px-1 px-md-3 center-vertical",
              staticStyle: { "justify-content": "center" }
            },
            [
              _c("img", {
                staticClass: "img-fluid",
                attrs: {
                  src: require("../../../static/img/landing/card4-8.png")
                }
              })
            ]
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row col-md-6 pt-3 pl-3 pl-md-4 pr-0" }, [
      _c("div", { staticClass: "col-4 col-md-4 pr-0 center-vertical" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card5-1.png") }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4 col-md-4 pr-0 center-vertical" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card2-10.svg") }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4 col-md-4 center-vertical pr-0" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card2-4.png") }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 pt-3" }, [
        _c(
          "div",
          {
            staticClass:
              "col-6 col-md-6 offset-3 offset-md-3 center-vertical pr-0"
          },
          [
            _c("img", {
              staticClass: "img-fluid",
              attrs: { src: require("../../../static/img/landing/card5-3.png") }
            })
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: { width: "130px", "margin-left": "15px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card6-16.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: {
          width: "130px",
          top: "-30px",
          "margin-left": "80px",
          "z-index": "3"
        }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card2-4.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: { width: "130px", "margin-left": "45px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card6-5.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: { width: "155px", "margin-left": "-320px", top: "120px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card6-9.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: { width: "130px", "margin-left": "120px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card6-3.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: { width: "130px", "margin-left": "40px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card6-5.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: { width: "130px", "margin-left": "-50px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card2-7.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: { width: "130px", "margin-left": "40px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card6-5.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: { width: "130px", "margin-left": "40px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card6-7.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: { width: "130px", "margin-left": "-230px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card6-6.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: { width: "130px", "margin-left": "15px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card6-8.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: {
          width: "130px",
          top: "-30px",
          "margin-left": "80px",
          "z-index": "3"
        }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card2-4.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: { width: "130px", "margin-left": "45px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card6-5.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: { width: "155px", "margin-left": "-320px", top: "120px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card6-9.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: { width: "130px", "margin-left": "110px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card6-3.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: { width: "130px", "margin-left": "40px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card6-5.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: { width: "260px", "margin-left": "-66px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card6-10.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: { width: "130px", "margin-left": "10px", top: "0px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card6-5.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: { width: "130px", "margin-left": "20px", top: "0px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card6-14.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: { width: "130px", "margin-left": "-215px", top: "0px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card2-8.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: { width: "200px", "margin-left": "-635px", top: "-66px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card6-11.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: { width: "155px", "margin-left": "5px", top: "120px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card6-9.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: { width: "230px", "margin-left": "-30px", top: "120px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card6-13.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: { width: "130px", "margin-left": "-26px", top: "202px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card2-7.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card6-img",
        staticStyle: { width: "280px", "margin-left": "-506px", top: "0px" }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../../../static/img/landing/card6-17.png") }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-93d60c14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93d60c14","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/landing.vue
// module id = null
// module chunks = 